// NIST 800-63B 5.1.1.2 Memorized Secret Verifiers (https://pages.nist.gov/800-63-3/sp800-63b.html)
// Verifiers SHOULD offer guidance to the subscriber, such as a password-strength meter [Meters], 
// to assist the user in choosing a strong memorized secret.This is particularly important following the rejection 
// of a memorized secret on the above list as it discourages trivial modification of listed (and likely very weak) 
// memorized secrets.
//
// IA-5.1 (g) Employ automated tools to assist the user in selecting strong password authenticators
// https://fedramp.scalesec.com/moderate/ia-5.1/
//
((document) => {
    [].slice.call(document.querySelectorAll('[data-password-meter]')).map((el: HTMLElement) => {
        const input = document.getElementById(el.dataset.passwordMeter!) as HTMLInputElement;

        const exprs: { expr: RegExp, count: number }[] = [
            { expr: /[a-z]/, count: 26 },
            { expr: /[A-Z]/, count: 26 },
            { expr: /[0-9]/, count: 10 },
            { expr: /[\\!"#\$%&\'\(\)\*\+,\-\./:;<=>\?@\[\]\^_`\{|\} ~]/, count: 33 }
        ];

        const setProgress = function (width: number, variant: string, text: string) {
            el.style.width = width + '%'
            el.className = 'progress-bar progress-bar-striped bg-' + variant;
            el.innerText = text;
            el.setAttribute('aria-valuenow', width.toString());
        }

        const update = function () {
            const pwd = input.value;

            if (!pwd) {
                setProgress(0, 'light', '');
                return;
            }

            const chars = exprs.reduce((val, rule) => rule.expr.test(pwd) ? val + rule.count : val, 0);

            const width = 5 * Math.min(20, Math.log10(Math.pow(chars, pwd.length)));

            if (pwd.length < 8) {
                setProgress(Math.min(50, width), 'danger', 'TOO SHORT');

            } else if (/^\d+$/.test(pwd) || /(.)\1{3}/.test(pwd) || pwd.split('').filter((ch, i) => pwd.indexOf(ch) === i).length <= 2) {
                setProgress(Math.min(50, width), 'danger', 'INSECURE');

            } else if (width < 75) {
                setProgress(width, 'warning', 'WEAK');

            } else if (width < 90) {
                setProgress(width, 'info', 'MEDIUM');

            } else {
                setProgress(width, 'success', 'STRONG');
            }
        }

        input.addEventListener("keyup", update);
        input.addEventListener("change", update);

        update();
    });

})(document);